import { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Hero } from '../sections/Hero';
import { RegistrationTicker } from '../sections/RegistrationTicker';
import { Explainer } from '../sections/Explainer';
import { Panelists } from '../sections/Panelists';
import { RunOfShow } from '../sections/RunOfShow';
import { ChatTeaser } from '../sections/ChatTeaser';
import { Roadmap } from '../sections/Roadmap';
import { SubmitTopic } from '../sections/SubmitTopic';
import { ApplyPanelist } from '../sections/ApplyPanelist';
import { Sponsors } from '../sections/Sponsors';
import { AIMinuteMondays } from '../sections/AIMinuteMondays';
import { BuiltByNexera } from '../sections/BuiltByNexera';
import { RegisterCTA } from '../sections/RegisterCTA';
import type { MascotName } from '../theme/ThemeProvider';

const REGISTRATION_CAP = 5000;

export function LandingPage({ mascot }: { mascot: MascotName }): JSX.Element {
  // Local registration counter — bumps via ticker simulation and the final CTA.
  // Will move to a server-broadcast counter in Phase 3.
  const [registrations, setRegistrations] = useState(2847);

  const bump = (n = 1): void => {
    setRegistrations((r) => Math.min(REGISTRATION_CAP, r + n));
  };

  return (
    <>
      <Header mascot={mascot} />
      <main>
        <Hero mascot={mascot} registrations={registrations} />
        <RegistrationTicker registrations={registrations} onTick={() => bump(1)} />
        <Explainer mascot={mascot} />
        <Panelists />
        <RunOfShow />
        <ChatTeaser />
        <Roadmap />
        <SubmitTopic />
        <ApplyPanelist />
        <Sponsors />
        <AIMinuteMondays mascot={mascot} />
        <BuiltByNexera />
        <RegisterCTA mascot={mascot} registrations={registrations} onRegister={() => bump(1)} />
      </main>
      <Footer mascot={mascot} />
    </>
  );
}
